import { render } from "./DashboardTags.vue?vue&type=template&id=4d9a6498"
import script from "./DashboardTags.vue?vue&type=script&lang=js"
export * from "./DashboardTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__